export default "__VITE_ASSET__DkxX2EP9__"